/***
 * 默认使用的主题颜色
 * @type {string}
 */
export const themeModeDefault = 'theme-dark'

/***
 * 支持的主题列表
 * @type {({theme: string, label: string, key: number}|{theme: string, label: string, key: number})[]}
 */
export const themes = [
  { theme: 'theme-light', label: '亮色', key: 0 },
  { theme: 'theme-dark', label: '暗色', key: 1 }
]

export const THEME_DARK = 'theme-dark'

export const THEME_LIGHT = 'theme-light'



// WEBPACK FOOTER //
// ./src/config/theme.js